export const updateDocTypeReceivedConfig= {
    list: 'InformationTracker',
    columns: {
        Id: {
            class: 'id',
            dataName: 'Id',
            type: 'number',
            title: 'Id',
            width: 100,
            hidden: true
        },
        SignaturePage:
        {
            class: "value",
            dataName: 'SignaturePage',
            type: 'string',
            title: 'Signature Page',
            width: 100,
            hidden: false,
            readOnly: false
        },
        Receive83b:
        {
            class: "value",
            dataName: 'Receive83b',
            type: 'string',
            title: '83(b)',
            width: 100,
            hidden: false,
            readOnly: false
        }
    },
}